import _styled from "styled-components";
import { memo } from 'react';
import {
/* Badge */
Button, Title } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EndCardJobOffer = function EndCardJobOffer(_ref) {
  var onButtonClick = _ref.onButtonClick;
  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: /*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsx(Title, {
        content: "Non perdere altre posizioni lavorative come queste",
        fontSize: "extraLarge",
        fontWeight: "semibold",
        twStyle: {
          "lineHeight": "1.5rem"
        }
      }), /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        title: "Salva ricerca",
        icon: "BellIconWhite",
        fullwidth: true,
        buttonSize: "large",
        onClick: onButtonClick
      })]
    })
  });
};
export default /*#__PURE__*/memo(EndCardJobOffer);

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "end-card-job-offer___StyledDiv",
  componentId: "sc-1opbtca-0"
})({
  "maxHeight": "13rem",
  "width": "100%",
  "maxWidth": "24rem",
  "borderRadius": "1rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(208 225 36 / var(--tw-bg-opacity))",
  "padding": "1rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "end-card-job-offer___StyledDiv2",
  componentId: "sc-1opbtca-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1rem"
});